import { render } from "./MonProfil.vue?vue&type=template&id=6fb00a2e&scoped=true&ts=true"
import script from "./MonProfil.vue?vue&type=script&lang=ts"
export * from "./MonProfil.vue?vue&type=script&lang=ts"

import "./MonProfil.vue?vue&type=style&index=0&id=6fb00a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb00a2e"]])

export default __exports__